/**
 * Shared keyboard rules for game hotkeys.
 *
 * While the player types (chat, search boxes, forms) no game hotkey may fire:
 * WASD / arrows / Q E Z C walk, Ctrl + them turn, Ctrl+Q logs out… Every
 * window-level key handler asks `typingInto(event)` first and leaves the key
 * to the field (copy, paste, select all keep working there).
 */

/** Inputs that take keys as text; checkboxes, radios, buttons and sliders do not. */
const NON_TEXT_INPUTS = new Set(['button', 'checkbox', 'color', 'file', 'image', 'radio', 'range', 'reset', 'submit']);

export function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  const tag = target.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT') return true;
  if (tag === 'INPUT') return !NON_TEXT_INPUTS.has((target as HTMLInputElement).type);
  return false;
}

/** The key event belongs to a text field (or an IME is composing): not a game hotkey. */
export function typingInto(event: KeyboardEvent): boolean {
  return event.isComposing || isTypingTarget(event.target) || isTypingTarget(document.activeElement);
}
